import React from 'react'

const Essential = () => {
  return (
    <>
      <div id='display-phone'>
<h5 style={{borderBottom:'3px solid #B3DDEF'}}>Daily   <span style={{color:'#B3DDEF',}}>Essential</span></h5>
<h5 style={{borderBottom:'3px solid black'}}>View All</h5>
 </div>
     <div>

     </div>
     <div id='Essential-container'>

     
     <div id='Essential-wrapper'>
        <img src="/asset/cat-1.png" alt="" srcset="" />
        <p>Daily Essential</p>
        <h5>Up to 50% Off</h5>
     </div>

      <div id='Essential-wrapper'>
        <img src="/asset/cat-2.png" alt="" srcset="" />
        <p>Strayberry</p>
        <h5>Up to 50% Off</h5>
     </div>


      <div id='Essential-wrapper'>
        <img src="/asset//cat-3.png" alt="" srcset="" />
        <p>mango</p>
        <h5>Up to 50% Off</h5>
     </div>


      <div id='Essential-wrapper'>
        <img src="/asset/cat-4.png" alt="" srcset="" />
        <p>Fruit</p>
        <h5>Up to 50% Off</h5>
     </div>

      <div id='Essential-wrapper'>
        <img src="/asset/cat-5.png" alt="" srcset="" />
        <p>cherry</p>
        <h5>Up to 50% Off</h5>
     </div>

      <div id='Essential-wrapper'>
        <img src="/asset/cat-6.png" alt="" srcset="" />
        <p>Vegetable</p>
        <h5>Up to 50% Off</h5>
     </div>
</div>
    </>
   
  )
}

export default Essential